/**
 * Created by claude on 22.07.26.
 * Scene component extracted from DifferencesScene
 */

class DifferencesSceneComponent extends ScriptComponent {
    onCreate() {
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
    }

    buildPhotos() {
        this.photos = new PhotoViews(this.node);
        this.photos.setAnchorPoint(0.5, 0.5);

        if (this.photos.isCloversForceAvailable()) {
            this.photos.showCloversForce();
        }

        return this.photos;
    }

    hasBoosters() {
        return !!(Game.currentGame.brushBooster || Game.currentGame.discoverBooster);
    }

    buildBoosters() {
        const styles = this.styles;

        const direction = cleverapps.resolution.mode === cleverapps.WideMode.SQUARE ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL;

        if (Game.currentGame.brushBooster) {
            const brushButton = new BrushButtonBooster(Game.currentGame.brushBooster);

            this.brushButton = new cc.Node();
            this.brushButton.addChild(brushButton);

            ComponentMap.attach(this.brushButton, new HidingComponent({
                direction,
                control: brushButton.getControlId()
            }));
        }

        if (Game.currentGame.discoverBooster) {
            const discoverButton = new DiscoverButtonBooster(Game.currentGame.discoverBooster);

            this.discoverButton = new cc.Node();
            this.discoverButton.addChild(discoverButton);

            ComponentMap.attach(this.discoverButton, new HidingComponent({
                direction,
                control: discoverButton.getControlId()
            }));
        }

        this.boosters = new cleverapps.Layout([this.brushButton, this.discoverButton].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.boosters.margin[cleverapps.resolution.mode]
        });
        this.boosters.setAlignment(styles.boosters.position);

        return this.boosters;
    }

    hasLightningRush() {
        return !!Game.currentGame.lightingRushMission;
    }

    buildLightningRushMarks() {
        this.lightningRushMarksView = new LightningRushMarksView();
        return this.lightningRushMarksView;
    }

    onReady() {
        Game.currentGame.on("block", this.coolDown.bind(this));

        Game.currentGame.competition.onChangeResultsListeners.hitAlarm = this.node.createListener(this.hintAlarm.bind(this));
    }

    onResize() {
        if (this.boosters) {
            this.boosters.setOptions({
                direction: cleverapps.UI.HORIZONTAL,
                margin: this.styles.boosters.margin[cleverapps.resolution.mode]
            });
        }
    }

    onAfterResize() {
        const overlappingList = [this.boosters, ComponentUtils.findComponentByName(this.node, "UpMenuController").node, ComponentMap.get(this.node, GameSceneComponent).playersView].filter(Boolean);
        cleverapps.UI.inflateToBoundaries(this.photos, overlappingList, {
            padding: this.styles.padding,
            maxScale: 1.5,
            lovesPosition: this.node.convertToWorldSpace(cc.p(this.node.width / 2, this.node.height / 2))
        });
    }

    hintAlarm(id) {
        const totalPoints = Game.currentGame.competition.options.algo.maxResult;
        const opponentPoints = Game.currentGame.competition.onGetOpponent().amount;

        if (id !== Game.currentGame.competition.player.id && opponentPoints === totalPoints - 1) {
            const booster = Game.currentGame.discoverBooster;
            if (booster && !booster.manualAlarm) {
                booster.startHint(true);

                cleverapps.effects.fire("differences.exclamation");
                cleverapps.audio.fadeOutAndEject();
                this.node.runAction(new cc.Sequence(
                    new cc.DelayTime(0.4),
                    new cc.CallFunc(() => {
                        cleverapps.audio.insertDisk(bundles.game.urls.intense_bgm);
                    })
                ));
            }
        }
    }

    coolDown() {
        let coolDownNode;

        const withForce = !cleverapps.forces.isShown(Forces.COOLDOWN_FORCE);
        cleverapps.focusManager.display({
            focus: "CoolDown",
            actions: [
                function (f) {
                    this.photos.toggleBlur(true, f);
                }.bind(this),

                function (f) {
                    const duration = cleverapps.parseInterval(Differences.BLOCK_DURATIONS[Game.currentGame.inflamer.stage]);
                    const warningsLeft = Differences.ALLOWED_MISTAKES - Game.currentGame.inflamer.stage;
                    coolDownNode = new CoolDownNode(duration, warningsLeft, !withForce && Game.currentGame.discoverBooster, this.closeCoolDownNode.bind(this));
                    this.node.addChild(coolDownNode, 1);

                    coolDownNode.showUp(f);
                }.bind(this),

                function (f) {
                    if (withForce) {
                        cleverapps.forces.create(coolDownNode, Forces.COOLDOWN_FORCE);
                        cleverapps.forces.onceForceClosed = this.closeCoolDownNode.bind(this);
                    }

                    this.closeCoolDownCallback = f;
                }.bind(this),

                function (f) {
                    coolDownNode.animateClose(f);
                },

                function (f) {
                    if (Game.currentGame && Game.currentGame.outcome === GameBase.OUTCOME_UNKNOWN) {
                        this.photos.toggleBlur(false);
                    }

                    f();
                }.bind(this)
            ]
        });
    }

    closeCoolDownNode() {
        if (cleverapps.forces.isRunningForce(Forces.COOLDOWN_FORCE)) {
            cleverapps.forces.closeRunningForce();
        }

        if (this.closeCoolDownCallback) {
            this.closeCoolDownCallback();
            this.closeCoolDownCallback = undefined;
        }
    }

    coolDownNodeActive() {
        return Boolean(this.closeCoolDownCallback);
    }
}

Prefab.registerComponent("DifferencesSceneComponent", DifferencesSceneComponent);

GameScene = bundles.main.jsons.differencesscene_prefab_json;